import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Send SMS to multiple recipients
 * @param {string[]} phoneNumbers - Array of phone numbers to send SMS to
 * @param {string} message - SMS message content
 * @param {boolean} isSms - Flag to indicate SMS type
 * @returns {Promise} - API response
 */
export const sendSms = async (phoneNumbers, message, isSms = true) => {
  try {
    // Format the payload according to API requirements
    const payload = {
      lsNumero: phoneNumbers,
      message: message,
      isSms: isSms
    };

    console.log('Sending SMS with payload:', payload);
    
    const response = await axios.post(`${API_URL}/sendsms`, payload, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('SMS API response:', response.data);
    return {
      success: true,
      data: response.data,
      message: `SMS envoyé avec succès à ${phoneNumbers.length} contact(s).`
    };
  } catch (error) {
    console.error('Error sending SMS:', error);
    
    // Extract error message for better user feedback
    const errorMessage = error.response?.data?.message || 
                         error.message || 
                         'Une erreur est survenue lors de l\'envoi des SMS.';
    
    return {
      success: false,
      error: error,
      message: errorMessage
    };
  }
};

/**
 * Format phone numbers for API consumption
 * @param {string[]} phones - Raw phone numbers
 * @returns {string[]} - Formatted phone numbers
 */
export const formatPhoneNumbers = (phones) => {
  return phones.map(phone => {
    // Remove any non-digit characters
    const digits = phone.replace(/\D/g, '');
    
    // Format according to API requirements (without +)
    return digits.startsWith('216') ? digits : `216${digits}`;
  });
};

/**
 * Validate phone number format (Tunisian number)
 * @param {string} phone - Phone number to validate
 * @returns {boolean} - True if valid
 */
export const validatePhoneNumber = (phone) => {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  
  // If it has the country code (216)
  if (digits.startsWith('216')) {
    return digits.length === 11 && /^216[2459]\d{7}$/.test(digits);
  }
  
  // Without country code, should be 8 digits starting with 2, 4, 5, or 9
  return digits.length === 8 && /^[2459]\d{7}$/.test(digits);
};